import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo } from "react";
import cx from "classnames";
import { ApplicationHeader } from "@jutro/router";
import { MetadataContent, resolveProps, resolveCallbackProps } from "@jutro/uiconfig";
import styles from "./AppFloorPlan.module.css";
var AppFloorPlanHeaderInternal = function (_ref) {
  var _headerProps$commonAv,
    _context,
    headerProps = _ref.headerProps,
    renderHeader = _ref.renderHeader,
    subHeaderProps = _ref.subHeaderProps,
    visibleRoutes = _ref.visibleRoutes,
    visibleLeftSideRoutes = _ref.visibleLeftSideRoutes,
    componentMap = _ref.componentMap,
    callbackMap = _ref.callbackMap,
    classNameMap = _ref.classNameMap;
  function resolveAllProps() {
    var allProps = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return resolveProps(allProps, callbackMap, classNameMap);
  }
  var resolvedHeaderProps = _objectSpread(_objectSpread({}, resolveAllProps(headerProps)), {}, {
      commonAvatarRoutes: null == headerProps || null === (_headerProps$commonAv = headerProps.commonAvatarRoutes) || void 0 === _headerProps$commonAv ? void 0 : _mapInstanceProperty(_headerProps$commonAv).call(_headerProps$commonAv, function (route) {
        return route && resolveAllProps(route);
      })
    }),
    resolvedSubHeaderProps = resolveAllProps(subHeaderProps),
    headerClasses = cx(resolvedHeaderProps.className, styles.header);
  if (renderHeader) return function (renderHeader, callbackMap, props) {
    if ("function" == typeof renderHeader) return renderHeader(props);
    var resolvedRenderHeader = resolveCallbackProps({
      renderHeader: renderHeader
    }, callbackMap).renderHeader;
    return null == resolvedRenderHeader ? void 0 : resolvedRenderHeader(props);
  }(renderHeader, callbackMap, {
    header: _objectSpread(_objectSpread({}, resolvedHeaderProps), {}, {
      className: headerClasses
    }),
    subHeader: subHeaderProps,
    navigationRoutes: visibleRoutes
  }) || null;
  var burgerMenuRoutes = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(visibleRoutes), _toConsumableArray(visibleLeftSideRoutes)),
    helpPopoverItems = null == headerProps ? void 0 : headerProps.helpPopoverItems;
  return React.createElement(ApplicationHeader, _extends({}, resolvedHeaderProps, {
    className: headerClasses,
    renderBurgerMenuCustomItem: null == resolvedSubHeaderProps ? void 0 : resolvedSubHeaderProps.renderCustomComponent,
    noDeprecationWarnings: ["HelpPopover", "HelpHeading", "HelpElement", "HelpLink", "HelpParagraph"],
    helpPopoverItems: (null == headerProps ? void 0 : headerProps.helpPopoverItems) && [React.createElement(MetadataContent, {
      uiProps: helpPopoverItems,
      resolveComponentMap: componentMap,
      resolveCallbackMap: callbackMap,
      resolveClassNameMap: classNameMap,
      key: "MetadataContentKey"
    })],
    burgerMenuRoutes: burgerMenuRoutes
  }));
};
AppFloorPlanHeaderInternal.displayName = "AppFloorPlanHeader";
export var AppFloorPlanHeader = memo(AppFloorPlanHeaderInternal);
AppFloorPlanHeaderInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanHeader"
}, AppFloorPlanHeaderInternal.__docgenInfo = {
  componentName: "AppFloorPlanHeader",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanHeader",
  methods: [],
  actualName: "AppFloorPlanHeaderInternal"
};